import {
  SEND_PROFILE_DATA,
  SEND_PROFILE_DATA_SUCCESS,
  SEND_PROFILE_DATA_FAILURE,
} from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false,
  profileData: [],
};

const sendProfileDataReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SEND_PROFILE_DATA:
      return { ...state, loading: true };
    case SEND_PROFILE_DATA_SUCCESS:
      return {
        ...state,
        profileData: action?.payload,
        loading: false,
      };
    case SEND_PROFILE_DATA_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default sendProfileDataReducer;
